import AllCountries from "../components/AllCountries";
import Breadcrumb from "../components/Breadcrumb";

const AllCountriesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="All Countries" />

      <AllCountries />
    </>
  );
};

export default AllCountriesPage;
